import { Component, EventEmitter, OnInit, Output, output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CreateUserModel } from '../../models/createUserModel';
import { CreateUserResult } from '../../models/createUserResult';
import { EnrollmentService } from '../../services/enrollment.service';
import { SnackbarService } from '../../services/snackbar.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SignupComponent implements OnInit {
  languages = [{ value: 'svenska', viewValue: 'Svenska' }, { value: 'english', viewValue: 'English' }];
  public createUserModel: CreateUserModel = new CreateUserModel(null);
  matcher = new MyErrorStateMatcher();
  createUserForm = new UntypedFormGroup({
    language: new UntypedFormControl(''),
    firstname: new UntypedFormControl('', Validators.required),
    lastname: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });
  userCreated = false;
  loading = false;
  @Output() userCreatedEvent = new EventEmitter();

  constructor(
    public _snackBar: SnackbarService,
    private dialogRef: MatDialogRef<SignupComponent>,
    public enrollmentService: EnrollmentService
  ) { }

  ngOnInit() {
    // console.log(this.createUserForm.value);
    // console.log(this.createUserForm.controls['language'].value);
  }

  createNewUser() {
    this.loading = true;
    this.enrollmentService
      .createUser(
        this.createUserForm.controls['email'].value,
        this.createUserForm.controls['firstname'].value,
        this.createUserForm.controls['lastname'].value,
        this.createUserForm.controls['language'].value
      )
      .subscribe({
        next: (result: CreateUserResult) => {
          const test = result;
          console.warn('USER CREATED', this.createUserForm.value);
          if (result && result.success) {
            this.createUserModel = new CreateUserModel(null);
            this._snackBar.openSnackBar('Användare skapad', 'OK');
            this.userCreated = true;
            this.userCreatedEvent.emit(true);
          } else {
            this._snackBar.openSnackBar(
              'Något gick fel, vänligen kontrollera dina uppgifter',
              'OK'
            );
          }
          this.loading = false;
        },
        error: (error: any) => {
          console.log(error);
          this._snackBar.openSnackBar('Något gick fel', 'OK');
          this.loading = false;
        }
      });
  }

  cancelForm() {
    this.createUserForm.reset();
    // this.dialogRef.close();
  }

  goToLogin() {
    this.userCreatedEvent.emit('openLogin');
  }

}
